import { Action } from 'redux-actions'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import api from '../../../services/api.services'
import { DivisionId } from '../../../services/api.types'
import { getGroupMembers, getGroupMembersFail, getGroupMembersSuccess } from './MyGroupsActions'

function* getGroupMembersSaga(action: Action<{ divisionId: DivisionId }>) {
  try {
    const { divisionId } = action.payload
    // @ts-ignore
    const response = yield call(api.activity.getGroupMembers, { divisionId })
    yield put(getGroupMembersSuccess(response))
  } catch (e) {
    yield put(getGroupMembersFail(e))
  }
}

export function* myGroupsSagas() {
  yield all([takeLatest(String(getGroupMembers), getGroupMembersSaga)])
}
